import scrollTo from '../func/scrollTo';

/**
 * 在元素上绑定点击事件, 点击该元素后页面滚动到给定的Dom
 * 使用方法: v-scroll="'#footer'" 或 v-scroll.300="'#footer'"
 * 使用方法: v-scroll="{target:'#footer', offset:-100}"
 */

export default {
	bind (el: HTMLElement, binding: any, vnode: any) {
		let bindTarget: string = '';
		let bindOffsetX: number = 0;
		let bindOffsetY: number = 0;
		if (Object.prototype.toString.call(binding.value) == '[object String]') {
			bindTarget = binding.value;
		} else if (Object.prototype.toString.call(binding.value) == '[object Object]') {
			bindTarget = binding.value.target || binding.value.value || '';
			bindOffsetX = binding.value.offsetX || binding.value.offset || 0;
			bindOffsetY = binding.value.offsetY || binding.value.offset || 0;
		}

		if (el.dataset) {
			el.dataset.scrollTarget = bindTarget;
		} else {
			el.setAttribute('data-scroll-target', bindTarget);
		}

		let duration: number = 500;
		for (let key in binding.modifiers) {
			const num: number = +key;
			if (Object.prototype.toString.call(num) == '[object Number]' && num > 0) {
				duration = num;
			}
		}

		(el as any)._scroll_handler = () => {
			let targetSelector: string = String(
				el.dataset ? el.dataset.scrollTarget : el.getAttribute('data-scroll-target'),
			);
			let target: any = document.querySelector(targetSelector);
			if (!target) {
				targetSelector = '#' + targetSelector.replace(/^#+/, '');
				target = document.querySelector(targetSelector);
			}
			if (!target) {
				targetSelector = '.' + targetSelector.replace(/^\.+/, '');
				target = document.querySelector(targetSelector);
			}
			duration = duration > 2000 ? 2000 : duration;
			target && scrollTo(target, duration, { offsetX: bindOffsetX, offsetY: bindOffsetY });
		};
		el.addEventListener('click', (el as any)._scroll_handler);
	},
	inserted (el: HTMLElement, binding: any, vnode: any) {},
	update (el: HTMLElement, binding: any, vnode: any) {
		if (el.dataset) {
			el.dataset.scrollTarget = binding.value;
		} else {
			el.setAttribute('data-scroll-target', binding.value);
		}
	},
	componentUpdated (el: HTMLElement, binding: any, vnode: any) {},
	unbind (el: HTMLElement, binding: any, vnode: any) {
		el.removeEventListener('click', (el as any)._scroll_handler);
	},
};
